@if (isReady()) {
  <div class="z-fx z-fx-center-center paertner-banner" [style.background-color]="backgroundColor">
    <div class="paertner-banner-content" [ngStyle]="textStyles" [innerHTML]="html | safeHtml"></div>
  </div>
}
